import { useState } from "react";
import WoSectionCard from "../common/WoSectionCard";
import AdminNotes from "./AdminNotes";

// Admin Notes section as an independent card matching the proposals/forms look.
function WoAdminNotes({ woId, refreshToken }) {
  const [count, setCount] = useState(0);

  return (
    <WoSectionCard
      title="Admin Notes"
      count={count}
      toolTip="This is a place make a quick note for users on the Browser App only. Viewable by all admins and accountants."
    >
      <AdminNotes woId={woId} refreshToken={refreshToken} onCount={setCount} />
    </WoSectionCard>
  );
}

export default WoAdminNotes;
